/**
 * Who filed the request. An operator may correct what the back office wrote;
 * what a customer asked for is theirs, and is read back rather than rewritten.
 */
export enum CancellationFlowSource {
  BACKOFFICE = 'BACKOFFICE',
  CUSTOMER = 'CUSTOMER',
}
